import axios from 'axios';

import type { RecordClaimMilestoneRequest } from '~/server_shared/openapi/data-contracts';

export const getClaimMilestonesUrl = (organizationId: number, claimId: number) =>
  `/api/v1/organizations/${organizationId}/claims/${claimId}/milestones`;

export const recordClaimMilestone = async (
  organizationId: number,
  claimId: number,
  milestoneKey: string,
  values: RecordClaimMilestoneRequest
): Promise<void> => {
  await axios.put(`${getClaimMilestonesUrl(organizationId, claimId)}/${milestoneKey}`, values);
};

export const clearClaimMilestone = async (
  organizationId: number,
  claimId: number,
  milestoneKey: string
): Promise<void> => {
  await axios.delete(`${getClaimMilestonesUrl(organizationId, claimId)}/${milestoneKey}`);
};
